
(function() {

    var infowindow, map, markers, markersRemaining, geocoder, bounds;

    var PRNemovitostiMaps = {
        items: {},
        options_default: {
            id: 'gmap',
            //center: new google.maps.LatLng(49.81, 15.46),
            zoom: 7,
            bounds_zoom: null,
            autozoom: true,
            markercluster_maxzoom: 13,
            url_ajax: null,
            url_icon: null,
        },
        initialize: function(items, options) {

            PRNemovitostiMaps.options = PRNemovitostiMaps.options_default;
            if (typeof options !== "undefined") {
                $.each(options, function(key, value) {
                    if (typeof PRNemovitostiMaps.options[key] !== "undefined") {
                        PRNemovitostiMaps.options[key] = value;
                    }
                });
            }
            PRNemovitostiMaps.items  = items;

            var options = {
                'zoom': PRNemovitostiMaps.options.zoom,
                'center': PRNemovitostiMaps.options.center,
                'mapTypeId': google.maps.MapTypeId.ROADMAP
            };

            infowindow = new google.maps.InfoWindow();
            map = new google.maps.Map(document.getElementById(PRNemovitostiMaps.options.id), options);
            markers = [];
            markersRemaining = PRNemovitostiMaps.items.length;
            geocoder = new google.maps.Geocoder();
            bounds = new window.google.maps.LatLngBounds();

            var $map = $('#'+PRNemovitostiMaps.options.id);
            $map.data('gmMap', map);
            $map.data('gmMarkers', markers);
            $map.data('gmBounds', bounds);

            if (typeof window.maps_colors != 'undefined') {
                map.set('styles', window.maps_colors);
            }

            if (typeof window.maps_marker_icon_anchor != 'undefined') {
                if (typeof window.maps_marker_icon != 'undefined') {
                    window.maps_marker_icon.anchor = new google.maps.Point(window.maps_marker_icon_anchor[0], window.maps_marker_icon_anchor[1]);
                }
                if (typeof window.maps_marker_icon_hover != 'undefined') {
                    window.maps_marker_icon_hover.anchor = new google.maps.Point(window.maps_marker_icon_anchor[0], window.maps_marker_icon_anchor[1]);
                }
            }
        },
        onAllMarkersLoaded: function () {
            var markerCluster = new MarkerClusterer(map, markers, {maxZoom: PRNemovitostiMaps.options.markercluster_maxzoom});
            if(PRNemovitostiMaps.options.markercluster_maxzoom === -1){
                return;
            }
            markerCluster.setCalculator(function(markers, numStyles) {
                var count = 0;
                for (var i in markers) {
                    if (typeof markers[i].count != 'undefined') {
                        count = count +  markers[i].count;
                    }
                    else {
                        count = count + 1;
                    }
                }
                return {
                    text: count,
                    index: count
                }
            });
        },
        saveLocation: function (item, loc_w, loc_l) {
            if (!PRNemovitostiMaps.options.url_ajax) {
                return;
            }

            var data = {};
            if (typeof item.id_zs != 'undefined')
                data['id_zs'] = item.id_zs;
            if (typeof item.id_uzivatel != 'undefined')
                data['id_uzivatel'] = item.id_uzivatel;
            data['adresa'] = item.adresa;
            data['loc_w'] = loc_w;
            data['loc_l'] = loc_l;
            data['status'] = 'ok';


            $.ajax({
                url: PRNemovitostiMaps.options.url_ajax,
                data: data
            });
        },
        addMarkerByAddress: function (item) {

            geocoder.geocode({address: item.adresa}, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    var marker = new google.maps.Marker({position: results[0].geometry.location, count: item.count, icon: PRNemovitostiMaps.images(item)});
                    markers.push(marker);
                    PRNemovitostiMaps.setBublinkaListener(item, marker);
                    PRNemovitostiMaps.saveLocation(item, results[0].geometry.location.lat(), results[0].geometry.location.lng());

                    var latLng = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                    bounds.extend(latLng);
                    // pokud zjistujeme adresu tak ce ceka na pozadavek do google, takze musime pak znovu vycentrovat protoze centrovani probehne drive nez prijde odpoved
                    PRNemovitostiMaps.center(map, bounds);

                    if (typeof item.add_marker_lisener != 'undefined' && item.add_marker_lisener) {
                        window[item.add_marker_lisener](map, item, marker);
                    }
                } else {
                    if (window.console && window.console.log) {
                        window.console.log("nenalezena pozice pro nemovitost: " + status + " " + item.adresa);
                    }

                    if (status == 'ZERO_RESULTS')
                    {
                        $.ajax({
                            url: PRNemovitostiMaps.options.url_ajax,
                            data: {'id_zs': item.id_zs, 'status': 'error'}
                        });
                    }
                }

                markersRemaining--;
                if (markersRemaining === 0) {
                    PRNemovitostiMaps.onAllMarkersLoaded();
                }
            });
        },
        addMarkerByLocation: function (item) {
            var latLng = new google.maps.LatLng(item.loc_w, item.loc_l);
            bounds.extend(latLng);

            var marker = new google.maps.Marker({'position': latLng,  count: item.count, icon: PRNemovitostiMaps.images(item)});
            markers.push(marker);
            PRNemovitostiMaps.setBublinkaListener(item, marker);

            if (typeof item.add_marker_lisener != 'undefined' && item.add_marker_lisener) {
                window[item.add_marker_lisener](map, item, marker);
            }

            markersRemaining--;
            if (markersRemaining === 0) {
                PRNemovitostiMaps.onAllMarkersLoaded();
            }
        },
        images: function (item)
        {
            if (typeof window.maps_marker_icon != 'undefined')
                return window.maps_marker_icon;


            if (item.icon) {
                return item.icon;
            }

            if (!PRNemovitostiMaps.options.url_icon) {
                return null;
            }
            var images = 'dum_1.png';
            if (item.pocet >= 2 && item.pocet <= 5) {
                images = 'dum_'+item.pocet+'.png';
            }
            else if (item.pocet > 5) {
                images = 'dum_5plus.png';
            }

            var ikona = {
                url: PRNemovitostiMaps.options.url_icon+images,
            };
            return ikona;
        },
        setHoverImages: function(item, marker) {
            if (typeof window.maps_marker_icon_hover == 'undefined') {
                return;
            }

            for (var i in markers) {
                markers[i].setIcon(PRNemovitostiMaps.images(item));
            }

            marker.setIcon(window.maps_marker_icon_hover);
        },
        setBublinkaListener: function (item, marker) {

            if (typeof item.bublinka == 'undefined') {
                return;
            }

            google.maps.event.addListener(marker, 'click', function() {
                infowindow.setContent(item.bublinka);
                infowindow.open(map, marker);

                PRNemovitostiMaps.setHoverImages(item, marker);
            });
            if (typeof item.bublinka_open != 'undefined' && item.bublinka_open) {
                infowindow.setContent(item.bublinka);
                infowindow.open(map,marker);
                PRNemovitostiMaps.setHoverImages(item, marker);
            }
        },
        run: function()
        {
            for (var i = 0; i < PRNemovitostiMaps.items.length; i++) {
                var item = PRNemovitostiMaps.items[i];
                if (item.loc_l && item.loc_w)
                    PRNemovitostiMaps.addMarkerByLocation(item);
                else
                    PRNemovitostiMaps.addMarkerByAddress(item);
            }

            PRNemovitostiMaps.center(map, bounds);
        },
        center: function(map, bounds)
        {
            if (PRNemovitostiMaps.options.autozoom && !bounds.isEmpty()) {
                map.fitBounds(bounds);
            }
            if (PRNemovitostiMaps.options.bounds_zoom) {
                map.setOptions({maxZoom: PRNemovitostiMaps.options.bounds_zoom});
            }
        },
    };
    window.PRNemovitostiMaps = PRNemovitostiMaps;
}());